import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';

export function valueMatchValidator(otherControlName: string): ValidatorFn {

    return function valueMatchValidate(control: AbstractControl): { [key: string]: boolean } | null {

        if (!control.parent) {
            return null;
        }

        const otherControl = control.parent.get(otherControlName) as FormControl;

        if (!otherControl) {
            return null;
        }

        const valueMatches = control.value === otherControl.value;

        return !valueMatches ? { valueMatch: true } : null;

    };
}
